// import categoryTracks from "../refs/categoryTracks"
import fillerObj from "./fillerObj"
import generateCategoricalTrack from "./generateCategoricalTrack"
import generateContinuousTrack from "./generateContinuousTrack"
import generateLayout from "./layout/generateLayout"
import generateTrack from "./generateTrackGroup"

/*
Output

Plotly trace group object (group of tracks)

{
    x: [...samples],
    y: [track],
    z: [...colorKeys],
    type: 'heatmap',
    colorscale,
    zmin,
    zmax,
    showscale: false,
    connectgaps: false,
    hoverongaps: true,
    autocolorscale: false,
}
 */

export default function generateHeatmap(
    {
        categoryTracks,
        genes,
        trackData,
        trackGroup,
        sampleOrder,
        shownDataTypes,
    }
  ) {

    const Plotly = window.Plotly
    console.log('track: ', trackGroup, trackData)
    
    console.log("looking at track data in heatmap.js");
    console.log(trackData);

    const nonStratifiedTrackData = Object.fromEntries(
      Object.entries(trackData).map(([key, value]) => [
          key.replace(/ (Male|Female)$/, ''), 
          value
      ])
  );

  // const shortenedPhosphoTrackData = Object.fromEntries(
  //   Object.entries(nonStratifiedTrackData).map(([key, value]) => [
  //     (key.includes("_")) ? key.split("-")[1] : key
  //     , 
  //     value
  // ])

  // );

  // const shortendGlycoTrackData = Object.fromEntries(
  //   Object.entries(nonStratifiedTrackData).map(([key, value]) => [
  //     (key.includes("-")) ? key.split("-")[1] : key
  //     , 
  //     value
  // ])

  // );

  trackData = nonStratifiedTrackData;
  console.log("printing new track data")
  console.log(trackData);




    let data = []
    // categorical clinical tracks
    // Object.entries(categoryTracks)
    //   .forEach(([category, trackList], i) => {
    //       if (category === 'Numerical') { return }
    if (trackGroup in categoryTracks && trackGroup !== 'Numerical') {
      const trackList = categoryTracks[trackGroup]

      addCategoryTrack({
        trackList,
        dataArr: data,
        trackData,
        sampleOrder,
        i: 0,
      })
    }
    // })

    // continuous clinical tracks
    if (trackGroup === 'Numerical') {
      categoryTracks.Numerical.forEach((track, i) => {
        const continuousTrack = generateContinuousTrack({
          sampleOrder,
          track: trackData[track],
        })
  
        data.push(continuousTrack)
      })
  
  
      // data.push(fillerObj({
      //   i: 1,
      //   samples: sampleOrder,
      //   marker: '*',
      // }))
    }

    // molecular tracks
    // genes.forEach((gene, y) => {
    
    if (trackGroup === 'Ungrouped') {
      genes.forEach((gene, y) => {
        const setCategories = Object.values(categoryTracks).flat()
            const geneTracks = Object.keys(trackData).filter(track => !setCategories.includes(track))
            
          })
    }

    console.log('trackGroup? ', genes, trackGroup)

    if (genes.includes(trackGroup)) {
      console.log('trackGroup? ', genes, trackGroup);
      const gene = trackGroup
      const geneTracks = Object.entries(trackData)

      // follow the order of Shown Data Types


      .filter(([, data]) => data.gene === gene 
      )

      console.log("printing gene tracks");
      console.log(geneTracks);
      
      // can include shown data types here
      geneTracks.forEach(([, track], i) => {
        const geneTrack = generateTrack({
          sampleOrder,
          track,
          i: 1,
        })
        data.push(geneTrack)
      })
    }

    data.reverse()

    // just needed for some mysterious plotly reason
    data.forEach((track) => {

      // console.log("printing track in data");
      // console.log(track);

      // if (track.y[1] && track.y[1].includes(" ")){
      // const varToChange = track.y[1].split(" ").slice(0, -1).join(" ");
      // track.y[1] = varToChange;
      // }

      // track.y[1] = track.y[1].replace(/ (Male|Female)$/, '');

      // console.log("modified track");
      // console.log(track);

      if (track) {
          track.z.splice(0,0,[])
          track.y.splice(0,0,'')
          track.xgap = 0.2
      }
    })

    // layout and config
    
    
    const layout = (trackGroup === "Ungrouped") ? generateLayout(data, "Clinical Annotations" ) : generateLayout(data, trackGroup);
    
    const config = { 
      repsonsive: true,
      displaylogo: false,
    }

    Plotly.newPlot(`plotly-heatmap-${trackGroup}`, data, layout, config)

    return document.getElementById(`plotly-heatmap-${trackGroup}`)
}


function addCategoryTrack({
  trackList,
  dataArr,
  trackData,
  sampleOrder,
  i
}) {
  trackList.forEach((track) => {

    const categoricalTrack = generateCategoricalTrack({
      sampleOrder,
      track: trackData[track],
    });

    // const categoricalTrackMale = generateCategoricalTrack({
    //   sampleOrder,
    //   track: trackData[track + " Male" ],
    // });

    // const categoricalTrackFemale = generateCategoricalTrack({
    //   sampleOrder,
    //   track: trackData[track + " Female"],
    // });

    dataArr.push(categoricalTrack)
    // dataArr.push(categoricalTrackMale)
    // dataArr.push(categoricalTrackFemale)
  })
  
  // dataArr.push(fillerObj({
  //   i: i + 1,
  //   samples: sampleOrder,
  //   marker: '-',
  // }))
}